module.exports = __webpack_public_path__ + "img/Mastercard_2019_logo.4423593b.svg";